import React, { useEffect, useState } from 'react';
import ManageItemsListComponent from './ManageItemsListComponent';
import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { FormControlNames, FormItemTypes } from '../../../utils/formBuilderUtils';
import useModalStrip from '../../../global-hooks/useModalStrip';
import _ from "lodash";

const textboxStyle = {
  minWidth: "100%",
  maxWidth: "100%",
  marginTop: 10,
};

const EditPropertiesComponent = (props) => {
  const { selectedControl, selectControl, editControlProperties, editContainerProperties } = props;
  const [updatedItem, setUpdatedItem] = useState({});
  const [isUpdatedItemRequired, setIsUpdatedItemRequired] = useState(false);
  const [moveControlObj, setMoveControlObj] = useState(null);
  const [controlsInContainer, setControlsInContainer] = useState(undefined);
  const { showModalStrip } = useModalStrip();

  useEffect(() => {
    if (selectedControl) {
      if (selectedControl.items) {
        setUpdatedItem({
          ...selectedControl,
          items: JSON.parse(JSON.stringify(selectedControl.items)),
        });
      } else {
        setUpdatedItem({ ...selectedControl });
      }
      if (selectedControl.hasOwnProperty('required')) {
        setIsUpdatedItemRequired(selectedControl.required);
      }
    }
    setMoveControlObj(null);
    setControlsInContainer(undefined);
  }, [selectedControl]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedItem((prevState) => ({
      ...prevState, [name]: value,
    }));
  };

  const addItemInList = (item) => {
    const newItems = _.cloneDeep(updatedItem.items);
    newItems.push(item);
    setUpdatedItem((prevState) => ({
      ...prevState, items: newItems,
    }));
  };

  const deleteItemFromList = (item) => {
    const newItems = updatedItem.items.filter((i) => i.id !== item.id);
    setUpdatedItem((prevState) => ({
      ...prevState, items: newItems,
    }));
  };

  const editIteminList = (item) => {
    const newItems = _.cloneDeep(updatedItem.items);
    const itemToBeReplaced = newItems.find((i) => i.id === item.id);
    itemToBeReplaced.value = item.value;
    itemToBeReplaced.label = item.label;
    setUpdatedItem((prevState) => ({
      ...prevState, items: newItems,
    }));
  };

  const handleCheckChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'required') {
      setIsUpdatedItemRequired(checked);
    }
    setUpdatedItem((prevState) => ({
      ...prevState, [name]: checked,
    }));
  };

  const onFormSubmit = (event) => {
    event.preventDefault();
    editControlProperties(updatedItem);
  };

  const onContainerFormSubmit = (event) => {
    event.preventDefault();
    editContainerProperties(updatedItem);
  };

  const handleMoveControlSelectChange = (e) => {
    const { name, value } = e.target;
    if (name === 'containerId') {
      const container = props.formLayoutComponents.find((con) => con.container.id === value);
      let stepsInContainer = container.children.length;
      if (selectedControl.containerId === value) {
        stepsInContainer -= 1;
      }
      setControlsInContainer(stepsInContainer);
    }
    setMoveControlObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getPositions = () => {
    if (controlsInContainer !== undefined) {
      return Array.from(Array(controlsInContainer + 1).keys()).map((item) => (
        <MenuItem key={item} value={item}>{item + 1}</MenuItem>
      ));
    }
    return null;
  };

  const onMoveControlFormSubmit = (e) => {
    e.preventDefault();
    if (!moveControlObj.containerId) {
      showModalStrip("danger", "You need to select Step first", 5000);
      return;
    }
    props.moveControlFromSide(selectedControl, moveControlObj);
  };

  return (
    <>
      {selectedControl ? (
        <>
          {updatedItem.itemType === FormItemTypes.CONTAINER ? (
            <>
              <div className="main-form">
                <form onSubmit={onContainerFormSubmit} style={{ minWidth: "100%" }}>
                  <div className="main-form-title">Edit Container Properties</div>
                  <div>
                    <TextField
                      label="Container Heading"
                      name="heading"
                      value={updatedItem.heading}
                      onChange={handleChange}
                      style={textboxStyle}
                    />
                  </div>
                  <div>
                    <TextField
                      label="Container Sub-Heading"
                      name="subHeading"
                      value={updatedItem.subHeading}
                      onChange={handleChange}
                      style={textboxStyle}
                    />
                  </div>
                  <input
                    type="submit"
                    className="btn btn-light btn-shadow m-t-20 m-r-10"
                    value="Update Data"
                  />
                  <input
                    type="button"
                    className="btn btn-light btn-shadow m-t-20 m-l-0"
                    value="Cancel"
                    onClick={() => {
                      if (selectControl) {
                        selectControl(undefined);
                      }
                    }}
                  />
                </form>
              </div>
            </>
          ) : (
            <>
              <div className="main-form">
                <form onSubmit={onFormSubmit} style={{ minWidth: "100%" }}>
                  <div className="main-form-title">Edit Field Properties</div>
                  <div>
                    <TextField
                      label="Field Label Name"
                      name="labelName"
                      value={updatedItem.labelName}
                      onChange={handleChange}
                      style={textboxStyle}
                    />
                  </div>
                  {updatedItem.controlName === FormControlNames.INPUTTEXTFIELD ||
                    updatedItem.controlName === FormControlNames.PHONEFIELD ||
                    updatedItem.controlName === FormControlNames.INPUTMULTILINE ||
                    updatedItem.controlName === FormControlNames.CHECKBOX ? (
                    <div>
                      <TextField
                        label="Field Placeholder"
                        name="placeholder"
                        value={updatedItem.placeholder}
                        onChange={handleChange}
                        style={textboxStyle}
                      />
                    </div>
                  ) : null}
                  <div>
                    <TextField
                      label="Field Description"
                      name="description"
                      value={updatedItem.description}
                      onChange={handleChange}
                      multiline
                      style={textboxStyle}
                    />
                  </div>
                  <div className="m-t-20 p-l-0">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isUpdatedItemRequired}
                          name="required"
                          onChange={handleCheckChange}
                        />
                      }
                      label="Required"
                    />
                  </div>
                  {(updatedItem.controlName === FormControlNames.RADIOGROUP ||
                    updatedItem.controlName === FormControlNames.SELECTDROPDOWN ||
                    updatedItem.controlName === FormControlNames.CHECKLIST) && (
                      <>
                        <h6>List Items</h6>
                        <ManageItemsListComponent
                          addItemInList={addItemInList}
                          editIteminList={editIteminList}
                          deleteItemFromList={deleteItemFromList}
                          items={updatedItem.items}
                        />
                      </>
                    )}
                  <input
                    type="submit"
                    className="btn btn-light btn-shadow m-t-20 m-r-10"
                    value="Update Data"
                  />
                  <input
                    type="button"
                    className="btn btn-light btn-shadow m-t-20 m-l-0"
                    value="Cancel"
                    onClick={() => {
                      if (selectControl) {
                        selectControl(undefined);
                      }
                    }}
                  />
                </form>
              </div>
              <div className="m-t-20"></div>
              <div className="main-form">
                <form onSubmit={onMoveControlFormSubmit} style={{ minWidth: "100%" }}>
                  <div className="main-form-title">Move Control to Step</div>
                  <div>
                    <FormControl style={{ minWidth: "100%" }}>
                      <InputLabel>Step:</InputLabel>
                      <Select
                        name="containerId"
                        value={moveControlObj?.containerId || ""}
                        onChange={handleMoveControlSelectChange}
                      >
                        {props.formLayoutComponents.map((item, ind) => (
                          <MenuItem key={item.container.id} value={item.container.id}>
                            Step {ind + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <FormControl style={{ minWidth: "100%" }}>
                      <InputLabel>Position:</InputLabel>
                      <Select
                        name="position"
                        value={moveControlObj?.position || ""}
                        onChange={handleMoveControlSelectChange}
                      >
                        {getPositions()}
                      </Select>
                    </FormControl>
                  </div>
                  <input
                    type="submit"
                    className="btn btn-light btn-shadow m-t-20 m-r-10"
                    value="Move Control"
                  />
                  <input
                    type="button"
                    className="btn btn-light btn-shadow m-t-20 m-l-0"
                    value="Cancel"
                    onClick={() => {
                      if (selectControl) {
                        selectControl(undefined);
                      }
                    }}
                  />
                </form>
              </div>
            </>
          )}
        </>
      ) : null}
    </>
  );
};

export default EditPropertiesComponent;
